
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 490.03 490.03"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M487.315 430.003l-225.1-389.9c-7.7-13.3-26.8-13.3-34.5 0l-225 389.9c-7.7 13.3 1.9 29.9 17.2 29.9h450.2c15.3 0 24.9-16.6 17.2-29.9zm-218.3-23.1h-48.9v-48.9h48.9v48.9zm.9-79h-49.8v-165.8h49.8v165.8z"}})])
          )
        }
      }
    